module.exports = __webpack_public_path__ + "img/stretch--genre1-img4.20c38d17.jpg";